import { useEffect } from 'react';
import { HotelRecord, Timeframe } from '../../../../common/types';
import { useKeenQuery } from '../../../../utils/keen';

const useOrderByCategoryData = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const [
    {
      data: totalOrdersByCategory = [],
      loading: isTotalOrdersByCategoryLoading,
    },
    queryTotalOrdersByCategory,
  ] = useKeenQuery<{ categoryId: string; result: number }[]>();

  useEffect(() => {
    queryTotalOrdersByCategory({
      analysisType: 'count',
      eventCollection: 'orders',
      groupBy: 'category_id',
      filters: [
        {
          propertyName: 'hotel_id',
          operator: 'eq',
          propertyValue: hotel.id,
        },
        {
          propertyName: 'test_order',
          operator: 'eq',
          propertyValue: false,
        },
      ],
      timeframe,
    });
  }, [hotel.id, queryTotalOrdersByCategory, timeframe]);

  return {
    data: totalOrdersByCategory,
    loading: isTotalOrdersByCategoryLoading,
  };
};

export default useOrderByCategoryData;
